import styled from 'styled-components'
import { CssVars } from '@bp-digital/theme'

export const TableAlert = styled.div`
  width: 100%;
  display: flex;
  justify-content: end;
  margin-bottom: ${CssVars.structure.spacing.md};
`
